export default __webpack_public_path__ + "static/media/google-icon.d179f01a.svg";